import { render, staticRenderFns } from "./kba.vue?vue&type=template&id=73bb1ccc&scoped=true&"
import script from "./kba.vue?vue&type=script&lang=js&"
export * from "./kba.vue?vue&type=script&lang=js&"
import style0 from "./kba.vue?vue&type=style&index=0&id=73bb1ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb1ccc",
  null
  
)

export default component.exports